<template>
  <section class="audiorecorder" id="audiorecorderSection">
    <div class="mouseover" @mouseenter="hover = true" @mouseout="mouseOut"></div>
    <Header />
    <div class="main-container" id="receiver">
      <div class="iframecontainer">
        <iframe class="gravador" id="the_iframe" :src="activityData.property.iframeSrc ? activityData.property.iframeSrc : activityData.property.src" frameborder="0" allow="camera;microphone"></iframe>
        <!-- <iframe class="gravador" id="the_iframe" src="https://demobooth.netlify.app/" frameborder="0" allow="camera"></iframe> -->
      </div>
      <!-- <div class="gallery">
         <Gallery :key="galleryKey" :images="images" :imagesSrc="imagesSrc"/>
        <Footer />  
      </div> -->
      <Footer />
    </div>
    <!-- <div class="iframe-footer-wrapper"> -->
    <!-- <Footer /> -->
    <!-- </div> -->
    <Spinner :showSpinner="showSpinner" />
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Gallery from '@/components/general/Gallery.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api';
import Spinner from '@/components/ui/Spinner.vue';

export default {
  name: 'AudioRecorder',
  components: {
    Header,
    Gallery,
    Footer,
    Spinner,
  },
  data() {
    return {
      hover: false,
      images: [],
      activityData: { images: {}, property: {}, interactivities: [] },
      currentLastPhotoId: '',
      imageObjects: [],
      imagesSrc: [],
      userAbleToPost: false,
      galleryKey: '',
      showSpinner: false,
    };
  },
  watch: {
    $route() {
      this.loadActivity();
    },
  },
  methods: {
    loadMoreImagesOnScroll(e) {
      // console.log('scrollingElemnt', { e });
      // console.log('scrollTop e.target', e.target.scrollingElement.scrollTop);
      // console.log('offsetHeight e.target', e.target.scrollingElement.offsetHeight);
      // console.log('clientHeight e.target', e.target.scrollingElement.clientHeight);
      // console.log('plus offset: ', e.target.scrollingElement.scrollTop + e.target.scrollingElement.offsetHeight);
      if (e.target.scrollingElement.scrollTop + e.target.scrollingElement.offsetHeight >= document.body.scrollHeight) {
        // console.log('scroll 0');
        // this.loadImages(this.imageObjects.length);
      }
    },
    mouseOut() {
      this.hover = true;
      setTimeout(() => {
        this.hover = false;
      }, 4000);
    },
    loadActivity() {
      api.get(`activity/${this.$route.params.stream}`).then((response) => {
        let tempImages = { ...this.activityData.images };
        this.activityData = { ...this.activityData, ...response.data };
        this.activityData.images = response.data.images ? JSON.parse(response.data.images) : tempImages;

        let tempProperty = { ...this.activityData.property };
        this.activityData.property = response.data.property ? JSON.parse(response.data.property) : tempProperty;
        // console.log('PROPERTY: ' + this.activityData.property);
      });
    },
    uploadPhoto(e) {
      console.log('ENTROU', typeof e.data, typeof e.data === 'string');

      if (typeof e.data === 'string' && JSON.parse(e.data).uri) {
        console.log('e: ' + JSON.stringify(e.data));
        this.showSpinner = true;
        let packet = JSON.parse(e.data);
        let byteString = atob(packet.uri.split(',')[1]);
        let ab = new ArrayBuffer(byteString.length);
        let ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        let blob = new Blob([ia], {
          type: 'audio/wav',
        });
        let file = new File([blob], `${this.$store.state.eventName}_${this.$store.state.user.name ? this.$store.state.user.name.replaceAll(' ', '') : 'Record'}.wav`);

        //console.log('uploadImage', type, e.target.files[0]);
        let formData = new FormData();
        formData.append('file', file);

        // console.log('METADATA SIZE: ' + file.size);
        if (file.size > 10) {
          api
            .post(`activity/${this.$route.params.stream}/materialUpload`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then((response) => {
              // console.log('file upload', response);
              // this.loadImages(this.imageObjects.length);
              this.showSpinner = false;
              //this.$router.go();

              // let mat = response.data;
              // if (mat) this.createFacebookMetaReference(mat.name, 'description', mat.url);

              api.post(`sessionAction/`, {
                action: 'AudioRecorder upload',
                properties: JSON.stringify({ route: this.$route.name, params: this.$route.params }),
                userid: this.$store.state.user.id,
                sessionid: this.$store.state.user.token,
                event_id: this.$store.state.eventId,
              });
            })
            .catch((err) => console.error(err));
        } else {
          this.showSpinner = false;
          alert('Could not generate image, sorry');
          return;
        }
      } else {
        return;
      }
    },
    createFacebookMetaReference(title, description, image) {
      let template = `
      <!DOCTYPE html>
        <html lang="en">

        <head>
          <meta charset="UTF-8">
          <meta http-equiv="X-UA-Compatible" content="IE=edge">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <meta property="og:url" content="https://gifbooth.netlify.app/facebook-bridge.html" />
          <meta property="og:type" content="image" />
          <meta id="og:title" property="og:title" content="${title}" />
          <meta property="og:description" content="${description}" />
          <meta id="og:image" property="og:image"
            content="${image}" />

          <title>FB-Bridge</title>
        </head>

        <body>
          <section>
            <img
              src="${image}">
          </section>
        </body>

        <style>
          html,
          body {
            margin: 0;
          }
          section {
            position: relative;
            min-height: 100dvh;
            display: flex;
            align-items: center;
            justify-content: center;
            background: black;
          }
          img {
            user-select: none;
            margin: auto;
            cursor: zoom-in;
            background-color: hsl(0, 0%, 90%);
            transition: background-color 300ms;
          }
          </style>
        </html>
      `;
      let blob = new Blob([template], { type: 'text/plain;charset=utf-8' });
      let file = new File([blob], `fb-bridge.html`);
      let formData = new FormData();
      formData.append('file', file);
      api
        .post(`activity/${this.$route.params.stream}/materialUpload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          console.log('createFacebookMetaReference', { response });
          // this.$router.go();
        })
        .catch((err) => console.error(err));
    },
    loadImages(offset) {
      let query = offset ? `?limit=20&page=${offset}` : '';
      // query = '?limit=100';
      // console.log(`activity/${this.$route.params.stream}/materialList${query}`);
      api
        .get(`activity/${this.$route.params.stream}/materialList${query}`)
        .then((response) => {
          // console.log('Material', response.data);
          let temp = [];
          response.data.forEach((element) => {
            temp.push(element.links);
            this.imageObjects.push(element);
            this.images.push(element);
            this.imagesSrc.push(element.links);
          });
          // this.images = temp;
          let lastMaterial = response.data.slice(-1)[0];
          this.currentLastPhotoId = lastMaterial ? lastMaterial.material_id : '';
          // console.log(this.currentLastPhotoId);
          !offset &&
            setTimeout((_) => {
              window.scrollTo(0, 0);
            }, 500);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    randomKey() {
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    },
  },
  beforeMount() {
    this.loadActivity();
    //this.loadImages();
  },
  mounted() {
    window.addEventListener('message', this.uploadPhoto);
    //document.addEventListener('scroll', this.loadMoreImagesOnScroll);
  },

  beforeDestroy() {
    window.removeEventListener('message', this.uploadPhoto);
    //document.removeEventListener('scroll', this.loadMoreImagesOnScroll);
  },
};
</script>

<style scoped lang="scss">
.audiorecorder {
  position: relative;
  background-color: var(--main-color);
  min-height: 100dvh;

  .mouseover {
    position: absolute;
    left: 0;
    pointer-events: auto;
    top: 0px;
    // background-color: red;
    width: 98vw;
    height: 120px;
  }
  .main-container {
    display: flex;
    flex-wrap: wrap;
    .iframecontainer {
      overflow-x: hidden;
      // padding: 2px;
      padding-left: 0;
      // margin-right: 2px;
      max-width: 100vw;
      .gravador {
        overflow: hidden !important;
        width: 100vw;
        // height: 110vh;
        // height: calc(100dvh + 25.25vw);
        height: calc(100dvh - 35px);
        // max-height: 100%;
        // background-color: rgb(5, 27, 27);
      }
    }
  }

  .gallery {
    background-color: transparent;
    position: absolute;
    // padding: 0 20px;
    top: calc(50px + 50.25vw);

    @include media('<=tablet') {
      top: calc(70px + 50.25vw);
    }
  }
}
.sticky-footer {
  position: relative;
  bottom: 0px;
}
</style>
